/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_Content_Feature_3_BodyInputs */

const en_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 100-foot Covershot canopy and ToughLie Golf Range 360 keep you swinging when the weather turns. Stay on your plan all season.`)
};

const es_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una cubierta Covershot de 100 pies y el ToughLie Golf Range 360 te permiten seguir practicando tu swing cuando cambia el clima. Mantén tu plan toda la temporada.`)
};

const de_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein 100 Fuß langes Covershot-Dach und die ToughLie Golf Range 360 sorgen dafür, dass Sie auch bei Wetterumschwung weiter trainieren können. Bleiben Sie die ganze Saison bei Ihrem Plan.`)
};

const zh_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`长 100 英尺的 Covershot 顶棚和 ToughLie Golf Range 360 让你在天气变化时也能继续练习挥杆。整个赛季都能按计划练习。`)
};

const ar_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مظلة Covershot بطول 100 قدم وToughLie Golf Range 360 تبقيانك تتدرب عندما يتغير الطقس. التزم بخطتك طوال الموسم.`)
};

const fr_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un auvent Covershot de 100 pieds et le ToughLie Golf Range 360 vous permettent de continuer à travailler votre swing quand la météo tourne. Restez fidèle à votre plan toute la saison.`)
};

const vi_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mái Covershot dài 100 feet và ToughLie Golf Range 360 giúp bạn tiếp tục swing khi thời tiết xấu. Giữ kế hoạch suốt cả mùa.`)
};

const sw_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paa la Covershot la futi 100 na ToughLie Golf Range 360 hukuwezesha kuendelea kufanya mazoezi ya swing hali ya hewa inapobadilika. Fuata mpango wako msimu mzima.`)
};

const th_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หลังคา Covershot ยาว 100 ฟุตและ ToughLie Golf Range 360 ช่วยให้คุณซ้อมสวิงต่อได้แม้สภาพอากาศจะเปลี่ยน ทำตามแผนของคุณได้ตลอดทั้งฤดูกาล`)
};

const bs_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Covershot nadstrešnica od 100 stopa i ToughLie Golf Range 360 omogućavaju vam vježbanje i kad se vrijeme promijeni. Ostanite na planu cijelu sezonu.`)
};

const ja_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全長100フィートのCovershotキャノピーとToughLie Golf Range 360があるので、天候が崩れてもスイング練習を続けられます。シーズンを通して計画どおりに練習しましょう。`)
};

const ko_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100피트 길이의 Covershot 캐노피와 ToughLie Golf Range 360 덕분에 날씨가 나빠져도 스윙을 계속할 수 있습니다. 시즌 내내 계획대로 연습하세요.`)
};

const pt_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma cobertura Covershot de 100 pés e o ToughLie Golf Range 360 permitem que você continue treinando quando o tempo muda. Siga seu plano durante toda a temporada.`)
};

const it_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una copertura Covershot di 100 piedi e il ToughLie Golf Range 360 ti permettono di continuare ad allenare lo swing quando il tempo cambia. Resta fedele al tuo piano per tutta la stagione.`)
};

const sv_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ett 100 fot långt Covershot-tak och ToughLie Golf Range 360 gör att du kan fortsätta träna när vädret slår om. Håll dig till din plan hela säsongen.`)
};

const nl_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een Covershot-overkapping van 100 voet en ToughLie Golf Range 360 laten je doortrainen als het weer omslaat. Houd het hele seizoen vast aan je plan.`)
};

const da_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En 100 fod lang Covershot-overdækning og ToughLie Golf Range 360 lader dig blive ved med at træne, når vejret slår om. Hold dig til din plan hele sæsonen.`)
};

const nb_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et 100 fot langt Covershot-tak og ToughLie Golf Range 360 lar deg fortsette å trene når været snur. Følg planen hele sesongen.`)
};

const fi_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 jalan mittainen Covershot-katos ja ToughLie Golf Range 360 pitävät harjoittelun käynnissä, vaikka sää kääntyisi. Pysy suunnitelmassasi koko kauden.`)
};

const pl_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadaszenie Covershot o długości 100 stóp i ToughLie Golf Range 360 pozwalają trenować swing nawet przy zmianie pogody. Trzymaj się planu przez cały sezon.`)
};

const ru_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100-футовый навес Covershot и ToughLie Golf Range 360 позволяют вам делать свинг, когда погода меняется. Следуйте своему плану весь сезон.`)
};

const tr_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 fitlik Covershot sundurması ve ToughLie Golf Range 360 sayesinde hava bozduğunda da swing çalışmaya devam edebilirsiniz. Tüm sezon boyunca planınıza sadık kalın.`)
};

const hi_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 फ़ुट लंबे Covershot शेड और ToughLie Golf Range 360 की बदौलत मौसम बिगड़ने पर भी आप स्विंग का अभ्यास जारी रख सकते हैं। पूरे सीज़न अपनी योजना पर टिके रहें।`)
};

const id_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanopi Covershot sepanjang 100 kaki dan ToughLie Golf Range 360 membuat Anda tetap bisa berlatih ayunan saat cuaca berubah. Tetap jalankan rencana Anda sepanjang musim.`)
};

const ms_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanopi Covershot sepanjang 100 kaki dan ToughLie Golf Range 360 membolehkan anda terus berlatih hayunan apabila cuaca berubah. Kekal dengan rancangan latihan anda sepanjang musim.`)
};

const cs_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přístřešek Covershot o délce 100 stop a ToughLie Golf Range 360 vám umožní trénovat švih, i když se počasí zhorší. Držte se svého plánu celou sezónu.`)
};

const el_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ένα στέγαστρο Covershot 100 ποδιών και το ToughLie Golf Range 360 σας επιτρέπουν να συνεχίζετε την προπόνηση όταν χαλάει ο καιρός. Μείνετε στο πρόγραμμά σας όλη τη σεζόν.`)
};

const he_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סככת Covershot באורך 100 רגל ו-ToughLie Golf Range 360 שומרים אתכם מתאמנים גם כשמזג האוויר משתנה. הישארו בתוכנית שלכם כל העונה.`)
};

const af_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`'n Covershot-afdak van 100 voet en ToughLie Golf Range 360 laat jou aanhou oefen wanneer die weer omslaan. Hou die hele seisoen by jou plan.`)
};

const hu_range_content_feature_3_body = /** @type {(inputs: Range_Content_Feature_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egy 100 láb hosszú Covershot tetőszerkezet és a ToughLie Golf Range 360 lehetővé teszi, hogy akkor is gyakorolj, ha romlik az idő. Tartsd magad a tervedhez egész szezonban.`)
};

/**
* | output |
* | --- |
* | "A 100-foot Covershot canopy and ToughLie Golf Range 360 keep you swinging when the weather turns. Stay on your plan all season." |
*
* @param {Range_Content_Feature_3_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_content_feature_3_body = /** @type {((inputs?: Range_Content_Feature_3_BodyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_Content_Feature_3_BodyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_content_feature_3_body(inputs)
	if (locale === "de") return de_range_content_feature_3_body(inputs)
	if (locale === "zh") return zh_range_content_feature_3_body(inputs)
	if (locale === "ar") return ar_range_content_feature_3_body(inputs)
	if (locale === "fr") return fr_range_content_feature_3_body(inputs)
	if (locale === "vi") return vi_range_content_feature_3_body(inputs)
	if (locale === "sw") return sw_range_content_feature_3_body(inputs)
	if (locale === "th") return th_range_content_feature_3_body(inputs)
	if (locale === "bs") return bs_range_content_feature_3_body(inputs)
	if (locale === "ja") return ja_range_content_feature_3_body(inputs)
	if (locale === "ko") return ko_range_content_feature_3_body(inputs)
	if (locale === "pt") return pt_range_content_feature_3_body(inputs)
	if (locale === "it") return it_range_content_feature_3_body(inputs)
	if (locale === "sv") return sv_range_content_feature_3_body(inputs)
	if (locale === "nl") return nl_range_content_feature_3_body(inputs)
	if (locale === "da") return da_range_content_feature_3_body(inputs)
	if (locale === "nb") return nb_range_content_feature_3_body(inputs)
	if (locale === "fi") return fi_range_content_feature_3_body(inputs)
	if (locale === "pl") return pl_range_content_feature_3_body(inputs)
	if (locale === "ru") return ru_range_content_feature_3_body(inputs)
	if (locale === "tr") return tr_range_content_feature_3_body(inputs)
	if (locale === "hi") return hi_range_content_feature_3_body(inputs)
	if (locale === "id") return id_range_content_feature_3_body(inputs)
	if (locale === "ms") return ms_range_content_feature_3_body(inputs)
	if (locale === "cs") return cs_range_content_feature_3_body(inputs)
	if (locale === "el") return el_range_content_feature_3_body(inputs)
	if (locale === "he") return he_range_content_feature_3_body(inputs)
	if (locale === "af") return af_range_content_feature_3_body(inputs)
	if (locale === "hu") return hu_range_content_feature_3_body(inputs)
	return en_range_content_feature_3_body(inputs)
});